<template>
	<div id="register">
		<div class="container">
			<router-link to="/" class="login-logo"></router-link>
			<p class="login-line">|</p>
			<p class="">通行证</p>
		</div>
		<div class="login-form">
			<div class="login-tit">艺人之家</div>
			<div class="" style="width: 300px;margin: 0 auto; font-size:16px">
				<div class="float-left login-tab">
					<router-link to='/login'>登录</router-link>
				</div>
				<div class="float-right login-tab login-tab-active">
					<router-link to='/register'>注册</router-link>
				</div>
				<div class="clearfix"></div>
			</div>
			<form class="form-style">
				<div class="input-log1">
					<i></i>
					<input v-model="mobile" type="text" placeholder="请输入您的手机号" required="required" />
				</div>
				<div class="input-log2">
					<i></i>
					<input v-model="password" type="password" placeholder="请输入密码（至少6位数）" />
				</div>
				<div class="input-log3">
					<i></i>
					<input v-model="code" type="text" placeholder="请输入手机验证码" />

				</div>
				<input v-show="show" @click="send(mobile)" class="yzm-btn3" type="button" value="发送验证码">
				<span v-show="!show" class="count">{{count}} s</span>
				<div class="identity">
					<RadioGroup v-model="identity" type="button">
						<Radio label="1">艺人</Radio>
						<Radio label="2">剧组</Radio>
						<Radio label="3">经纪人</Radio>
					</RadioGroup>
				</div>
				<input style="margin-top: 30px;" class="btn" @click="register()" type="button" value="注册" />

			</form>
		</div>
		<div class="clearfix"></div>


	</div>

</template>

<script>
	export default {
		data() {
			return {
				show: true,
				count: '',
				timer: null,
				mobile: "",
				password: "",
				code: "",
				identity: ""
			};
		},
		methods: {
			send(mobile) {
				var api = "http://api.yopoo.cn/api/v1/code"
				if (mobile == "") {
					this.$message({
						message: '请输入手机号！',
						type: 'warning',
						center: true

					});
				}
				if (this.password == "") {
					this.$message({
						message: '请输入密码！',
						type: 'warning',
						center: true

					});
				} else {

					this.$http.post(api, {
						'mobile': this.mobile
					}).then(
						res => {

							if (res.data.code == 200) {
								this.$message({
									message: res.data.msg,
									type: 'success',
									center: true

								});

								const TIME_COUNT = 90; //验证码倒计时
								if (!this.timer) {
									this.count = TIME_COUNT;
									this.show = false;
									this.timer = setInterval(() => {
										if (this.count > 0 && this.count <= TIME_COUNT) {
											this.count--;
										} else {
											this.show = true;
											clearInterval(this.timer);
											this.timer = null;
										}
									}, 1000)
								}
							}
							if (res.data.code == 202) {
								this.$message({
									message: res.data.msg,
									type: 'warning',
									center: true

								});
							}

						},
						err => {
							console.log(err);
						}
					);
				}
			},

			register() {
				var api = "http://api.yopoo.cn/api/v1/register";

				if (
					this.mobile == "" ||
					this.password == "" ||
					this.code == "" ||
					this.identity == ""
				) {
					this.$message({
						message: '请填写完整信息！',
						type: 'warning',
						center: true

					});
				}

				this.$http
					.post(api, {
						mobile: this.mobile,
						password: this.password,
						code: this.code,
						identity: this.identity
					}).then(res => {
						(this.submitted = true);
						if (res.data.code == '200') {
							setTimeout(
								function() {
									this.$message({
										message: res.data.msg,
										type: 'success',
										center: true

									});
									this.$router.push("/login");
								}.bind(this),
								1000
							);
						}
						if (res.data.code == '202') {
							this.$message({
								message: res.data.msg,
								type: 'warning',
								center: true

							});

						}
					});
			}
		}
	};
</script>
<style lang="less" rel="stylesheet">
	.yzm-btn3,
	.count {
		width: 80px;
		height: 30px;
		background: #000;
		border: none;
		color: #fff;
		font-size: 12px;
		border-radius: 5px;
		position: relative;
		top: -48px;
		margin-left: 210px;
		cursor: pointer;
		display: block;
		text-align: center;
		line-height: 30px;
	}

	.yzm-btn3:hover {
		background: #555;
	}

	.identity {
		height: 40px;
		margin-top: -20px;
	}

	.identity label {
		width: 68px
	}

	#register .login-form {
		height: 600px;
	}

	.count {
		font-size: 14px;
	}
	#register{
		.container {
			display: flex;
			align-items: center;
			width: 1200px;
			margin: 0 auto;
			font-size: 32px;
			color: #fff;
			vertical-align: top;
			font-weight: bold;
			margin-top: 40px;

			.login-line {
				padding: 0 20px;
			}

			.login-logo {
				width: 200px;
				height: 46px;
				background: url("http://yopoo.oss-cn-beijing.aliyuncs.com/logo.png") no-repeat center center;
				background-size: 100% 100%;
				display: inline-block;
			}

		}
	}

</style>



// WEBPACK FOOTER //
// src/components/Register.vue